module.exports = __webpack_public_path__ + "img/order-date.a12e02c2.svg";